import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import MediaGalleryItem from '../MediaGalleryItem/MediaGalleryItem';
import GenericGalleryCarousel from '../GenericGalleryCarousel/GenericGalleryCarousel';
import { useLoaded } from '../MainContent/useComponentLoading';
const RelatedContentGallery = (props) => {
    const { media } = props;
    useLoaded(props);
    return (_jsx(_Fragment, { children: (media === null || media === void 0 ? void 0 : media.length) && (_jsx(GenericGalleryCarousel, { ItemComponent: MediaGalleryItem, items: media, isFromMediaGallery: true, isFromRelatedContentGallery: true })) }));
};
export default RelatedContentGallery;
